import React, { useEffect, useState } from 'react';

// components
import Header from '../../components/Header/Header';
import Breadcrumbs from '../../components/Breadcrumbs';

// icons
import icon from '../../brand/generated/sidebar/equipment.svg';
import { useNavigate, useParams } from 'react-router-dom';
import HookForm from '../../components/HookForm/HookForm';
import InputNumeric from '../../components/Inputs/Input/InputNumeric';
import SelectEquipmentType from '../../components/Selects/SelectEquipmentType';
import getEquipments from '../../api/deals/getEquipments';
import LoaderInline from '../../components/Loader/LoaderInline';
import editEquipments from '../../api/equipments/editEquipment';
import SelectCity from '../../components/Selects/SelectCity';

const formStyles = {
  equipment: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a a' 'b b c c' 'e e e e' 'd d d d'` },
  other: { display: 'grid', gap: '20px' },
};

const EditEquipment = () => {
  const navigate = useNavigate();
  const { containerId, equipmentId } = useParams();
  const [data, setData] = useState({});
  const equipment = [
    {
      type: 'input',
      name: 'title',
      label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ',
      style: { gridArea: 'a' },
      rules: { required: true },
      defaultValue: data?.title,
    },
    {
      component: SelectEquipmentType,
      name: 'typeId',
      label: 'ÐÐ´Ð¸Ð½Ð¸ÑÐ° Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      rules: { required: true },
      defaultValue: { value: data?.typeId, label: data?.typeId === 1 ? 'Ð¨ÑÑÐºÐ°' : 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑ' },
    },
    {
      component: InputNumeric,
      name: 'count',
      label: 'ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾',
      rules: { required: true },
      defaultValue: data?.count,
    },
    {
      component: InputNumeric,
      name: 'price',
      label: 'Ð¦ÐµÐ½Ð°, KZT',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐµÐ½Ñ',
      style: { gridArea: 'c' },
      rules: { required: true },
      defaultValue: data?.price,
    },
    {
      component: SelectCity,
      name: 'cityId',
      label: 'ÐÐ¾ÑÐ¾Ð´',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'e' },
      rules: { required: true },
      defaultValue: { value: data?.cityId, },
    },
    {
      name: 'comment',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð´Ð¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ð¸',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð¾Ð± Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ð¸',
      style: { gridArea: 'd' },
      defaultValue: data?.comment,
    },
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEquipments({ containerId, id: equipmentId }).then((res) => {
      const equipment = res?.data?.equipments?.[0];

      setData(equipment);
      setLoading(false);
    });
  }, [equipmentId, containerId]);

  const onSave = (values) => {
    setLoading(true);
    editEquipments({
      ...values,
      id: equipmentId,
      containerId,
      typeId: values.typeId?.value || values.typeId,
    })
      .then(() => {
        navigate(-1);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) return <LoaderInline />;

  return (
    <HookForm
      inputs={equipment}
      title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¼ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ð¸'}
      grid={formStyles.equipment}
      border
      onSubmit={onSave}
      action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
    />
  );
};

export default EditEquipment;
